// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6ccec5e3","435":"135234ad","782":"6dc0f590"}[chunkId] + ".chunk.js";
};